/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 89e71c9ddfc4f5e195bbf3bdd324e26f3e7e738832d888f557cb736067f7e093
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './Button.style'

type ButtonOwnProps = {
  className?: string
  buttonStyle?: 'dropShadow'
  disabled?: boolean
  iconLeft?: React.ReactNode
  iconRight?: React.ReactNode
  isLoading?: boolean
  size?: 'default' | 'inline'
  variant?: 'default' | 'secondary' | 'severe' | 'severeSecondary' | 'noShell' | 'inline' | 'inlineMuted' | 'inlineSevere'
}

export type ButtonProps = ButtonOwnProps & Omit<ComponentProps<'button'>, keyof ButtonOwnProps>

function Button(props: ButtonProps): ReactElement {
  const {
    children,
    className = '',
    buttonStyle,
    disabled = false,
    iconLeft,
    iconRight,
    isLoading = false,
    size: _size = 'default',
    variant = 'default',
    ...rest
  } = props

  return (
    <button
      className={cn('Button', className, buttonStyle, variant, { disabled, isLoading })}
      css={style}
      {...rest}
      disabled={disabled || isLoading}
      type={rest.type ?? 'button'}
    >
      {iconLeft}
      {children}
      {iconRight}
    </button>
  )
}

export default Button
